import ky from 'ky';
import moment from 'moment';

//#region Legacy Application information
declare global {
  interface Window {
    appEnv?: string;
    loggedIn: string|false;
    application: LegacyApplicationInformation;
  }
}

export interface LegacyApplicationInformation {
  /**
   * Идентификатор авторизованного пользователя
   * NOTE: Не логично, но дабы не ломать логику старого приложения пришлось оставить
   */
  id: number;

  /** Идентификатор авторизованного пользователя */
  userId: number|null;

  /** Не понятно что имеется ввиду, но значение всегда true */
  activated: boolean;

  /** Приложение запущено в режиме демо-доступа */
  demo: boolean;

  appMode: 'standalone'|string;

  /** Временная зона, по которой работает бэкенд */
  timezone: string;

  /** Домен сервиса видео-трансляции */
  streamServiceUrl: string;

  /**
   * Информация о первых визитах
   * Используется в app/controller/analytics.js
   * 
   * Фортмат:
   * {
   *   [ID точки]: 'дата в текстовом формате (1999-07-20 14:20:00)',
   *   ...
   * }
   */
  firstVisits: Record<number, string>;  
}

/**
 * Задает глобальные настройки для станого приложения
 * (настройки хранятся в объекте window)
 */
export function setupLegacyOptionsGlobal() {
  moment.locale('ru');
  
  window.loggedIn = false;
  window.application = {
    id: 0,
    userId: null,
    demo: false,
    activated: true,
    appMode: '',
    timezone: 'Europe/Moscow',
    streamServiceUrl: '',
    firstVisits: {},
  };
}

//#endregion

export interface ApplicationOptionsDto {
  userId: string;
  activated: boolean;
  demo: boolean;
  appMode: string;
  env: string;
  timezone: string;
  streamServiceUrl: string;
  firstVisits: Record<number, string>;
}

export interface ControlOptionsDto {
  loggedIn: string|false;
  application: ApplicationOptionsDto;
}

/**
 * Загрузит все необходимые настройки кабинета управляющего с сервера
 * 
 * @throws {Error}
 * @returns 
 */
export async function loadControlOptions(): Promise<ControlOptionsDto> {
  try {
    return await ky.get<ControlOptionsDto>('/api/control/options').json();    
  } catch {
    throw new Error('Не удалось получить настойки с сервера');
  }
}

/**
 * Установит полученные с сервера настройки
 * 
 * @param opt 
 */
export async function setLegacyOptions(opt: ControlOptionsDto) {
  window.loggedIn = opt.loggedIn;

  if (opt.application.env) {
    window.appEnv = opt.application.env;
  }

  Object.assign(window.application, opt.application, {
    id: opt.application.userId ?? 0,
  });

  moment.tz.setDefault(opt.application.timezone);
}
